import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: theme.spacing(2),
  },
  error: {
    marginTop: theme.spacing(1),
  },
  fileName: {
    flex: 1,
    minWidth: 0,
  },
  label: {
    alignItems: 'center',
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    maxWidth: '100%',
  },
}));

export default useStyles;
